var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticStyle:{"background-color":"#ebebeb"}},[_c('v-container',{staticStyle:{"height":"100% !important"},attrs:{"fluid":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }